import { ChangeStaffPasswordRequest } from 'types/add-staff-user/change-staff-password';
import { apiSlice } from '../api/api-slice';

const changeStaffPasswordApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        changeStaffPassword: builder.query<void, ChangeStaffPasswordRequest>({
            query: (
                changeStaffPasswordRequest: ChangeStaffPasswordRequest,
            ) => ({
                url:
                    '/admin/change-staff-password/' +
                    changeStaffPasswordRequest.id,
                method: 'PATCH',
                body: { ...changeStaffPasswordRequest },
            }),
        }),
    }),
});
export const { useLazyChangeStaffPasswordQuery } = changeStaffPasswordApi;
